import ReactOnRails from 'react-on-rails';

import { ShinsotsuSchoolInfoForm } from 'bundles/lp/shinsotsu_common';

ReactOnRails.register({
  ShinsotsuSchoolInfoForm: ShinsotsuSchoolInfoForm
});
